import React, { useMemo } from "react";
import { makeStyles } from "@material-ui/core";
import { Field } from "react-final-form";
import Autocomplete from "../../../../components/Autocomplete";
import DegreeField from "../../../degree/components/DegreeField";
import MajorField from "../../../major/components/MajorField";
import { INTAKES, IntakeType, PROGRAM_TYPES } from "../../constants";
import { useQuery } from "react-query";
import useProgramQueriesHigher from "../../hooks/useProgramQueriesHigher";

const useStyles = makeStyles(() => ({
  formControl: {
    marginTop: 21,
  },
}));

const FilterFormHigher = () => {
  const classes = useStyles();

  const { fetchCountriesContainingPrograms } = useProgramQueriesHigher();

  const { isLoading, isFetching, data } = useQuery<any>(
    "countriesContainingProgramsHigher",
    fetchCountriesContainingPrograms,
  );

  const intakes = useMemo(
    () => INTAKES.filter((intake) => intake.id !== IntakeType.OUTDATED),
    [],
  );

  return (
    <>
      <div className={classes.formControl}>
        <Field
          fullWidth
          multiple={true}
          name="higher.countries"
          label="Country"
          placeholder="Country"
          options={data?.data}
          loading={(isFetching || isLoading).toString()}
          disabled={isLoading || isFetching}
          disableCloseOnSelect
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <DegreeField
          fullWidth
          name="higher.degree"
          label="Degree"
          placeholder="Degree"
        />
      </div>
      <div className={classes.formControl}>
        <MajorField
          fullWidth
          name="higher.major"
          label="Major"
          placeholder="Major"
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="higher.programType"
          label="Program Type"
          placeholder="Program Type"
          options={PROGRAM_TYPES}
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="higher.intake"
          label="Intake"
          placeholder="Intake"
          options={intakes}
          component={Autocomplete}
        />
      </div>
    </>
  );
};

export default React.memo(FilterFormHigher);
